/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CorrectRecordingRequestEditsInner
 */
export interface CorrectRecordingRequestEditsInner {
    /**
     * 
     * @type {string}
     * @memberof CorrectRecordingRequestEditsInner
     */
    op: CorrectRecordingRequestEditsInnerOpEnum;
    /**
     * 
     * @type {string}
     * @memberof CorrectRecordingRequestEditsInner
     */
    field: string;
    /**
     * str | list[str] | bool per contract
     * @type {object}
     * @memberof CorrectRecordingRequestEditsInner
     */
    value: object;
}


/**
 * @export
 */
export const CorrectRecordingRequestEditsInnerOpEnum = {
    Edit: 'edit',
    Add: 'add',
    Delete: 'delete'
} as const;
export type CorrectRecordingRequestEditsInnerOpEnum = typeof CorrectRecordingRequestEditsInnerOpEnum[keyof typeof CorrectRecordingRequestEditsInnerOpEnum];


/**
 * Check if a given object implements the CorrectRecordingRequestEditsInner interface.
 */
export function instanceOfCorrectRecordingRequestEditsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function CorrectRecordingRequestEditsInnerFromJSON(json: any): CorrectRecordingRequestEditsInner {
    return CorrectRecordingRequestEditsInnerFromJSONTyped(json, false);
}

export function CorrectRecordingRequestEditsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectRecordingRequestEditsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': json['op'],
        'field': json['field'],
        'value': json['value'],
    };
}

export function CorrectRecordingRequestEditsInnerToJSON(value?: CorrectRecordingRequestEditsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'field': value.field,
        'value': value.value,
    };
}

